// championshipPlayer_

export const pp_championshipPlayerDefaultValuesUpdate = {
  championshipPlayer: {
    id: '', // test 9d73d07a-0bb0-f011-bbd3-000d3a7e9b3a

    // base
    name: '',
    firstName: '',
    lastName: '',
    // Championship Address
    championshipAddressLine1: '',
    championshipAddressLine2: '',
    championshipCountry: {
      id: '',
      logicalName: '',
      name: '',
    },
    championshipCountyOrState: '',
    championshipEmail: '',
    championshipMobile: '',
    championshipMobileCountryCode: '',
    championshipPostcodeOrZipcode: '',
    championshipTownOrCity: '',

    // Player Address
    playerAddressCountry: {
      id: '',
      logicalName: '',
      name: '',
    },
    playerAddressLine1: '',
    playerAddressLine2: '',
    playerCountyOrState: '',
    playerPostcodeOrZipCode: '',
    playerTownOrCity: '',

    // Hospitality / Complimentary / Paid
    finalDayComplimentary: '',
    finalDayPaid: '',
    fridayComplimentary: '',
    fridayPaid: '',
    mondayComplimentary: '',
    mondayPaid: '',
    saturdayComplimentary: '',
    saturdayPaid: '',
    sundayComplimentary: '',
    sundayPaid: '',
    thursdayComplimentary: '',
    thursdayPaid: '',
    tuesdayComplimentary: '',
    tuesdayPaid: '',
    wednesdayComplimentary: '',
    wednesdayPaid: '',

    // Sustainability
    sustainabilityCarbonOffset: '',
    sustainabilityCarbonOffsetOther: '',
    sustainabilityDepartureCity: '',
    sustainabilityDestinationCity: '',
    sustainabilityMethodOfTransportArrival: '',
    sustainabilityMethodOfTransportDeparture: '',

    // championshipPlayer_

    // Tax
    taxAddressCountry: {
      id: '',
      logicalName: '',
      name: '',
    },
    taxAddressLine1: '',
    taxAddressLine2: '',
    taxCountyOrState: '',
    taxDocKeyContact: '',
    taxPostcodeOrZipcode: '',
    taxTownOrCity: '',
    countryOfTaxation: {
      id: '',
      logicalName: '',
      name: '',
    },

    // Ticketing
    ticketingContactEmail: '',
    ticketingContactName: '',

    // PlayerTour Affiliation
    tourAffiliation: {
      id: '',
      logicalName: '',
      name: '',
    },

    // Sections completed status
    contactDetailsSectionComplete: false,
    playerHomeAddressSectionComplete: false,
    championshipAddressSectionComplete: false,
    prizeMoneySectionComplete: false,

    //has started pre-registration flag
    hasStartedPreRegistration: false,
  },
};
